import { mdiChevronRight } from '@mdi/js';
import React from 'react';
import { Spinner } from '../base';
import * as S from './claims-bundle-badge.styles';

export interface IRelatedClaimsBadgeProps {
    className?: string;
    claimBundleIds: string[];
    forceClaims?: boolean;
    onCopy?: (url: string) => void;
    onRemove?: () => void;
    loading?: boolean;
    onFetchClaims?: () => void;
}

export const ClaimsBundleBadge: React.FunctionComponent<IRelatedClaimsBadgeProps> = React.memo(
    (props: IRelatedClaimsBadgeProps): React.ReactElement | null => {
        const { className, loading, claimBundleIds, forceClaims, onCopy, onRemove, onFetchClaims } = props;

        const handleFetchClaims = (e: React.MouseEvent<Element, MouseEvent>) => {
            e.stopPropagation();
            onFetchClaims && onFetchClaims();
        };

        if (claimBundleIds.length > 0) {
            return (
                <S.Wrapper className={className}>
                    {claimBundleIds.map(id => (
                        <S.ClaimBadge
                            key={id}
                            forceClaim={forceClaims}
                            claimId={id}
                            onCopy={onCopy}
                            onRemove={onRemove}
                            openInNewTab={true}>
                            Claim ID – {id}
                        </S.ClaimBadge>
                    ))}
                </S.Wrapper>
            );
        }

        if (!!onFetchClaims) {
            return (
                <S.Wrapper className={className}>
                    {!!onFetchClaims && (
                        <S.Badge disabled={!!loading}>
                            <S.ExpandButton variant="text" disabled={loading} onClick={handleFetchClaims}>
                                Show Related Claims
                            </S.ExpandButton>

                            <S.ActionButton onClick={handleFetchClaims}>
                                {loading ? (
                                    <Spinner size="18px" />
                                ) : (
                                    <S.ExpandIcon path={mdiChevronRight} size={0.75} />
                                )}
                            </S.ActionButton>
                        </S.Badge>
                    )}
                </S.Wrapper>
            );
        }

        return null;
    },
);
